import ReviewPipelineCRUD from "./ReviewPipelineCRUD";

export default ReviewPipelineCRUD;
